import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import toast from 'react-hot-toast';
import api from '../../api';
import { Building2 } from 'lucide-react';
import ListPageHeader from '../../components/list/ListPageHeader';
import ListLoadingState from '../../components/list/ListLoadingState';
import ListEmptyState from '../../components/list/ListEmptyState';
import ListPagination from '../../components/list/ListPagination';
import { ShortCardGrid, ListSection } from '../../components/list/ShortCard';
import { CampusShortCard } from '../../components/list/ShortCardVariants';
import { parsePaginated, DEFAULT_LIST_PAGE_SIZE } from '../../utils/listHelpers';

function Campuses() {
  const [campuses, setCampuses] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(12);

  const fetchCampuses = async () => {
    setLoading(true);
    try {
      const res = await api.get('/campuses/campuses/', { params: { page, page_size: pageSize } });
      const { results, count } = parsePaginated(res);
      setCampuses(results.filter((c) => c?.is_active));
      setTotalCount(count);
    } catch (e) {
      toast.error('Failed to load campuses.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCampuses();
  }, [page, pageSize]);

  return (
    <DashboardLayout>
      <main className="page-container content-width ux-list-page">
        <ListPageHeader
          kicker="Organisation"
          kickerIcon={Building2}
          title="Campuses"
          description="Browse and manage organisation campuses."
        />

        {loading ? (
          <ListLoadingState label="Loading campuses…" />
        ) : campuses.length === 0 ? (
          <ListEmptyState icon={Building2} title="No active campuses" description="No active campuses were found." />
        ) : (
          <ListSection title="Active campuses" description="Each campus runs its own catalog and learner community.">
            <ShortCardGrid className="ux-short-grid-wide">
              {campuses.map((c, index) => (
                <CampusShortCard key={c.id} campus={c} index={index} />
              ))}
            </ShortCardGrid>
          </ListSection>
        )}

        {!loading && campuses.length > 0 && (
          <ListPagination
            page={page}
            pageSize={pageSize}
            totalCount={totalCount}
            onPageChange={setPage}
            onPageSizeChange={(size) => { setPageSize(size); setPage(1); }}
            pageSizes={[8, 12, 24]}
          />
        )}
      </main>
    </DashboardLayout>
  );
}

export default Campuses;
